import { Component, Renderer2 } from '@angular/core';
import { TraceClass } from '@sentry/angular';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MixpanelService } from 'taxtank-core/common';
import { MatDialog } from '@angular/material/dialog';
import { filter, pairwise } from 'rxjs';
import { map } from 'rxjs/operators';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
@TraceClass()
export class AppComponent {
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private mpService: MixpanelService,
    private dialog: MatDialog,
    private viewportScroller: ViewportScroller,
    translate: TranslateService,
  ) {
    // Get loader Html element and hide it
    const loaderElement = this.renderer.selectRootElement('#root-preloader');
    this.renderer.setStyle(loaderElement, 'display', 'none');

    // this language will be used as a fallback when a translation isn't found in the current language
    translate.setDefaultLang('enum');
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use('en');
    // init web analytics
    this.mpService.init();

    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(event => event.urlAfterRedirects.split('?')[0]),
      pairwise(),
    ).subscribe(([previous, current]) => {
      // close modals if page changed
      if (previous !== current) {
        // scroll top
        document.querySelector('.content-wrapper').scrollTop = 0;
        this.closeModals();
      }
      // track page view
      this.mpService.trackPageView();
    });
  }

  // @TODO: taxtankit move close dialog when AbstractDialog will be created
  closeModals(): void {
    if (this.dialog.openDialogs.length) {
      this.dialog.closeAll();
    }
  }
}
